import { useTranslation } from "../../hooks/useTranslation";
import { StyledTypography } from "./ArrowWithLabelHint.style";

export const ArrowWithLabelHint: React.FC<{
  x: any;
  config: any;
}> = ({ x, config}) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledTypography
        variant="body1"
        compact={x.compact}
      >
        {x.text !== undefined && <>{x.text}</>}
        {x.isHTML && x.labelId !== undefined && (
          <div
            dangerouslySetInnerHTML={{
              __html: t(x.labelId).replace(/\r?\n/g, "<br />"),
            }}
          ></div>
        )}
        {!x.isHTML && x.labelId !== undefined && <>{t(x.labelId)}</>}
      </StyledTypography>

      {/*x.arrowLocation === "end" && (
        <img
          className={classes.icon}
          alt=""
          src={config.arrowIcon}
          width={x.arrowWidth ?? 50}
          height={x.arrowHeight ?? 50}
          style={x.arrowCssProps}
        ></img>
      )*/}
    </>
  );
};
